import _toConsumableArray from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from "react";
import { Children, useRef, useEffect, useReducer, useCallback, cloneElement } from "react";
import classnames from "classnames";
import { useIntersectionObserver } from "@/hooks";
import DropdownMenu from "@/components/DropdownMenu";
import styles from "@/styles/OverflowMenu.module.scss";
import dropDownStyles from "@/styles/DropdownMenu.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var IconEllipsis = function IconEllipsis(props) {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      d: "M1.5,0A1.5,1.5,0,1,1,0,1.5,1.5,1.5,0,0,1,1.5,0Zm6,0A1.5,1.5,0,1,1,6,1.5,1.5,1.5,0,0,1,7.5,0Zm6,0A1.5,1.5,0,1,1,12,1.5,1.5,1.5,0,0,1,13.5,0Z",
      fill: "#e3e4e5"
    })
  }));
};

IconEllipsis.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "15",
  height: "3",
  viewBox: "0 0 15 3"
};

function MenuItem(_ref) {
  var index = _ref.index,
      intersectCallback = _ref.intersectCallback,
      root = _ref.root,
      children = _ref.children;
  var item = useRef();
  var opts = {
    root: root,
    rootMargin: "3px",
    threshold: 1.0
  };
  var intersect = useIntersectionObserver(item, opts);
  useEffect(function () {
    intersectCallback(intersect, index);
  }, [intersect]);
  return /*#__PURE__*/_jsx("li", {
    className: classnames(styles.item, _defineProperty({}, styles.intersect, intersect)),
    ref: item,
    children: /*#__PURE__*/_jsx("div", {
      className: styles.itemInner,
      children: children
    })
  });
}

export default function OverflowMenu(_ref2) {
  var className = _ref2.className,
      children = _ref2.children;
  var root = useRef();

  var _useReducer = useReducer(function (state, action) {
    switch (action.type) {
      case "add":
        return [].concat(_toConsumableArray(state), [action.index]);

      case "remove":
        return state.filter(function (idx) {
          return idx != action.index;
        });
    }
  }, []),
      state = _useReducer[0],
      dispatch = _useReducer[1];

  var callback = useCallback(function (intersect, index) {
    if (intersect) {
      dispatch({
        type: "remove",
        index: index
      });
    } else {
      dispatch({
        type: "add",
        index: index
      });
    }
  }, []);
  return /*#__PURE__*/_jsxs("div", {
    className: classnames(styles.container, className),
    children: [/*#__PURE__*/_jsx("ul", {
      className: styles.menu,
      ref: root,
      children: Children.map(children, function (child, i) {
        return /*#__PURE__*/_jsx(MenuItem, {
          index: i,
          intersectCallback: callback,
          root: root.current,
          children: child
        }, "menu-item-".concat(i));
      })
    }), /*#__PURE__*/_jsx("div", {
      className: classnames(styles.dropdown, _defineProperty({}, styles.show, state.length > 0)),
      children: /*#__PURE__*/_jsx(DropdownMenu, {
        button: /*#__PURE__*/_jsx(IconEllipsis, {}),
        scopedClass: dropDownStyles.forOverflowMenu,
        mouseOver: true,
        right: true,
        children: /*#__PURE__*/_jsx("div", {
          className: dropDownStyles.item,
          children: state.sort().map(function (idx) {
            var element = Children.toArray(children)[idx];
            if (!element) return null;
            return /*#__PURE__*/cloneElement(element, {
              key: "overflow-dropdown-menu-".concat(idx)
            });
          })
        })
      })
    })]
  });
}